module.exports = __webpack_public_path__ + "static/media/ic-gift-blue.7eda8e79.svg";